import React, { Component } from "react";
import "antd/dist/antd.css";
import {
    citySearch,
    jobIndustryList,
    getLocalities,
    qualificationList,
    searchSkill,
    educationqualificationList,
    courseSpecializationList,
    jobRoleList,
} from "../../action/jobs";
import {
    getStorage,
    onChange,
    setIsRequired,
    setOptions,
    validateForm,
} from "../../utils";
import { Typeahead } from "react-bootstrap-typeahead";
import "suneditor/dist/css/suneditor.min.css";
import Loader from "../Common/Loader";
import Multiselect from "multiselect-react-dropdown";

export default class PostAJob extends Component {
    constructor(props) {
        super(props);
        const detail = this.props.Data;
        debugger
        this.state = {
            WORK_EXP_MIN: {
                name: "WORK_EXP_MIN",
                value: detail ? detail.WORK_EXP_MIN : "",
                error: "",
                isRequired: true,
            },
            WORK_EXP_MAX: {
                name: "WORK_EXP_MAX",
                value: detail ? detail.WORK_EXP_MAX : "",
                error: "",
                isRequired: true,
            },




            KEYWORDS: {
                name: "KEYWORDS",
                value: detail ? detail.KEYWORDS : [],
                options: [],
                error: "",
                isRequired: true,
            },
            INDUSTRY_ID: {
                name: "INDUSTRY_ID",
                value: detail ? detail.INDUSTRY_ID : "",
                options: [],
                error: "",
                isRequired: true,
            },




            JOB_DESCRIPTION: {
                name: "JOB_DESCRIPTION",
                value: detail ? detail.JOB_DETAILS : "",
                options: [],
                error: "",
                isRequired: true,
            },

            WORK_EXP_TYPE: {
                name: "WORK_EXP_TYPE",
                value: (detail.WORK_EXP_MIN === '0' && detail.WORK_EXP_MAX !== '0')
                    ? 'BOTH'
                    : (detail.WORK_EXP_MIN === '0' && detail.WORK_EXP_MAX === '0')
                        ? 'FRESHER'
                        : 'EXPERIENCED',
                error: "",
                isRequired: true,
            },
            GENDER: {
                name: "GENDER",
                value: detail ? detail.GENDER : "BOTH",
                error: "",
                isRequired: false,
            },
            AGE_MIN: {
                name: "AGE_MIN",
                value: detail ? detail.MIN_AGE : "",
                error: "",
                isRequired: false,
            },
            AGE_MAX: {
                name: "AGE_MAX",
                value: detail ? detail.MIN_AGE : "",
                error: "",
                isRequired: false,
            },
            SELECTED_SKILLS: detail ? detail.KEYWORDS : [],
            SELECTED_QUALIFICATION: {
                value: detail ? detail.QUALIFICATION_ID.map((data, index) => {
                    return {
                        QUALIFICATION_ID: data.QUALIFICATION_ID,
                        QUALIFICATION_NAME: data.QUALIFICATION_NAME,
                        label: data.QUALIFICATION_NAME
                    }
                }) : [], name: 'SELECTED_QUALIFICATION', error: "",
                isRequired: true
            },

            SELECTED_EDUCATION_QUALIFICATION: detail
                ? detail.EDUCATION_QUALIFICATION_ID.map((data, index) => {
                    return {
                        EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
                        COURSE_STREAM: data.COURSE_STREAM,
                        label: data.COURSE_STREAM
                    }
                })
                : [],
            SELECTED_COURSE_SPECIALIZATION: detail
                ? detail.COURSE_SPECIALIZATION.map((data, index) => {
                    return {
                        SPECIALIZATION_ID: data.SPECIALIZATION_ID,
                        SPECIALIZATION: data.SPECIALIZATION,
                        label: data.SPECIALIZATION
                    }
                })
                : [],
            QualificationList: [],
            EducationQualificationList: [],
            SPECIALIZATIONList: [],
            KEYWORD: '',
            QualificationsearchKey: false,
            EducationQualificationsearchKey: false,
            SPECIALIZATIONsearchKey: false
        };
    }
    componentDidMount() {
        this.getEducationQualificationList(this.state.SELECTED_QUALIFICATION.value.map((i) => {
            return i.QUALIFICATION_ID
        }))
        this.getQualificationList()
        this.getcourseSpecializationList(this.state.SELECTED_EDUCATION_QUALIFICATION.map((i) => {
            return i.EDUCATION_QUALIFICATION_ID
        }))
        this.loadlist();

    }
    getQualificationList = (e) => {
        qualificationList({ KEYWORD: e }).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        QUALIFICATION_ID: data.QUALIFICATION_ID,
                        QUALIFICATION_NAME: data.QUALIFICATION_NAME,
                        label: data.QUALIFICATION_NAME
                    }
                })
                this.setState({
                    QualificationList: d || [],
                    QualificationsearchKey: true,
                })
            }
        });

    }
    getcourseSpecializationList = (list) => {
        courseSpecializationList(list).then((res) => {
            console.log(res.result, "resultcourseSpecializationList");
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        SPECIALIZATION_ID: data.SPECIALIZATION_ID,
                        SPECIALIZATION: data.SPECIALIZATION,
                        label: data.SPECIALIZATION
                    }
                })
                this.setState({
                    SPECIALIZATIONList: d || [],
                    SPECIALIZATIONsearchKey: true
                })
            }
        });

    }
    getEducationQualificationList = (list) => {
        educationqualificationList(list).then((res) => {
            if (res.status) {
                let d = res.result && res.result.map((data, index) => {
                    return {
                        EDUCATION_QUALIFICATION_ID: data.EDUCATION_QUALIFICATION_ID,
                        COURSE_STREAM: data.COURSE_STREAM,
                        label: data.COURSE_STREAM
                    }
                })
                this.setState({
                    EducationQualificationList: d || [],
                    EducationQualificationsearchKey: true
                })
            }
        });

    }

    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value);
    };


    onSubmit = (e) => {

        e.preventDefault();
        const {
            SELECTED_SKILLS,
        } = this.state;
        if (SELECTED_SKILLS.length > 0) {
            onChange(this, "KEYWORDS", SELECTED_SKILLS);
        }
        if (validateForm(this)) {
            const {
                INDUSTRY_ID,
                SELECTED_SKILLS,
                SELECTED_QUALIFICATION,
                JOB_DESCRIPTION,
                SELECTED_EDUCATION_QUALIFICATION,
                SELECTED_COURSE_SPECIALIZATION,
                WORK_EXP_MIN,
                WORK_EXP_MAX,
                AGE_MIN,
                AGE_MAX,
                GENDER,
            } = this.state;


            const model = {
                WORK_EXP_MIN: WORK_EXP_MIN.value,
                WORK_EXP_MAX: WORK_EXP_MAX.value,
                KEYWORDS: SELECTED_SKILLS,
                JOB_DETAILS: JOB_DESCRIPTION.value,
                INDUSTRY_ID: INDUSTRY_ID.value,
                QUALIFICATION_ID: SELECTED_QUALIFICATION.value,
                EDUCATION_QUALIFICATION_ID: SELECTED_EDUCATION_QUALIFICATION,
                COURSE_SPECIALIZATION: SELECTED_COURSE_SPECIALIZATION,
                GENDER: GENDER.value,
                AGE_MIN: AGE_MIN.value,
                AGE_MAX: AGE_MAX.value,
            };
            if (this.props.JOB_ID) {
                model.JOB_ID = this.props.JOB_ID;
            }

            console.log(model)
            this.props.onSubmit(model);
        }
    };


    render() {
        const {
            WORK_EXP_MIN,
            WORK_EXP_MAX,
            KEYWORDS,
            INDUSTRY_ID,
            SELECTED_SKILLS,
            SELECTED_QUALIFICATION,
            JOB_DESCRIPTION,
            SELECTED_EDUCATION_QUALIFICATION,
            SELECTED_COURSE_SPECIALIZATION,
            WORK_EXP_TYPE,
            GENDER,
            AGE_MIN, AGE_MAX



        } = this.state;


        return (
            <React.Fragment>
                {this.props.showLoader && <Loader />}
                <section className="pricing-area padding-bottom-80px">
                    <div className="container">
                        <div className="row mt-2">
                            <div className="col-lg-12">
                                <div className="billing-form-item mb-0">
                                    <div className="billing-title-wrap">
                                        <h3 className="widget-title pb-0">Candidate Requirements</h3>

                                        <div className="title-shape margin-top-5px"></div>
                                    </div>
                                    <form onSubmit={(e) => this.onSubmit(e)}>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">
                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">We’ll use these requirement details to make your job visible to the right candidates.
                                                        </span>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full pt-3">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Minimum Qualification
                                                                {" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>

                                                            <div >
                                                                <Multiselect
                                                                    placeholder='Select Qualification Type'
                                                                    className={SELECTED_QUALIFICATION.error.length > 0 ? "is-invalid" : ''}
                                                                    style={{
                                                                        optionContainer:
                                                                            this.state.QualificationsearchKey ? { display: 'block' } : { display: 'none' }
                                                                    }}
                                                                    options={this.state.QualificationList}
                                                                    onSelect={(selectedValue) => {
                                                                        onChange(this, SELECTED_QUALIFICATION.name, selectedValue)
                                                                        this.getEducationQualificationList(selectedValue.map((item) => {
                                                                            return item.QUALIFICATION_ID
                                                                        }))

                                                                    }}
                                                                    onRemove={(selectedValue) => {
                                                                        onChange(this, SELECTED_QUALIFICATION.name, selectedValue)
                                                                    }}

                                                                    onSearch={(e) => {
                                                                        this.getQualificationList(e)
                                                                    }
                                                                    }
                                                                    selectedValues={SELECTED_QUALIFICATION.value}
                                                                    displayValue={"QUALIFICATION_NAME"}
                                                                    name={SELECTED_QUALIFICATION.name}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Key Skills{" "}
                                                                <span className="text-danger font-size-16">
                                                                    *
                                                                </span>
                                                            </label>
                                                            <p>
                                                                Specify key skills required for this job
                                                                role
                                                            </p>

                                                            <div>
                                                                {SELECTED_SKILLS.map((item) => {
                                                                    return (
                                                                        <span className="locationbox">
                                                                            {item.SKILL}{" "}
                                                                            <i
                                                                                onClick={() => {
                                                                                    this.deleteSKills(item.SKILL);
                                                                                }}
                                                                                className="fa fa-close"
                                                                            ></i>
                                                                        </span>
                                                                    );
                                                                })}
                                                            </div>
                                                            <div className="form-group">
                                                                <Typeahead
                                                                    id="ta-skill-ids"
                                                                    clearButton={false}
                                                                    labelKey={(option) => `${option.SKILL}`}
                                                                    multiple={true}
                                                                    options={KEYWORDS.options}
                                                                    onInputChange={(e) => {
                                                                        this.onKeywordPress(e, "SKILL");
                                                                    }}
                                                                    onChange={(e) => {
                                                                        this.skillsOnChange(e);
                                                                    }}
                                                                    placeholder="Add New Skill"
                                                                    className={
                                                                        KEYWORDS.error.length > 0
                                                                            ? "errorMsg"
                                                                            : ""
                                                                    }
                                                                    emptyLabel
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full">
                                                        <div className="input-box">
                                                            <label className="label-text pb-1">
                                                                Total experience required{' '}
                                                                <span className="text-danger font-size-16">*</span>
                                                            </label>
                                                            <div className="wfhduring">
                                                                <ul>
                                                                    <li>
                                                                        <input
                                                                            type="radio"
                                                                            checked={WORK_EXP_TYPE.value === 'FRESHER'}
                                                                            onClick={() => { onChange(this, 'WORK_EXP_TYPE', "FRESHER"); }}
                                                                        />
                                                                        <div className="wfhheading">
                                                                            Fresher Only
                                                                            <p>This job is for fresher candidates only.</p>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <input
                                                                            type="radio"
                                                                            checked={WORK_EXP_TYPE.value === 'EXPERIENCED'}
                                                                            onClick={() => { onChange(this, 'WORK_EXP_TYPE', "EXPERIENCED"); }}
                                                                        />
                                                                        <div className="wfhheading">
                                                                            Experienced Only
                                                                            <p>This job is for experienced candidates only.</p>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <input
                                                                            type="radio"
                                                                            checked={WORK_EXP_TYPE.value === 'BOTH'}
                                                                            onClick={() => { onChange(this, 'WORK_EXP_TYPE', "BOTH"); }}
                                                                        />
                                                                        <div className="wfhheading">
                                                                            Fresher and Experienced Both
                                                                            <p>This job is open to both fresher and experienced candidates.</p>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>

                                                            {(WORK_EXP_TYPE.value == 'EXPERIENCED' || WORK_EXP_TYPE.value == 'BOTH') && (
                                                                <React.Fragment>
                                                                    <div className="row">
                                                                        <div className="col-lg-2">
                                                                            <div className="form-group">
                                                                                <input
                                                                                    className={
                                                                                        WORK_EXP_MIN.error.length > 0
                                                                                            ? "form-control is-invalid"
                                                                                            : "form-control"
                                                                                    }
                                                                                    type="number"
                                                                                    min="0"
                                                                                    placeholder="Min"
                                                                                    name={WORK_EXP_MIN.name}
                                                                                    value={WORK_EXP_MIN.value}
                                                                                    onChange={(e) => this.onChange(e)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <span className="mob-span">to</span>
                                                                        <div className="col-lg-2">
                                                                            <div className="form-group">
                                                                                <input
                                                                                    className={
                                                                                        WORK_EXP_MAX.error.length > 0
                                                                                            ? "form-control is-invalid"
                                                                                            : "form-control"
                                                                                    }
                                                                                    type="number"
                                                                                    min="0"
                                                                                    placeholder="Max"
                                                                                    name={WORK_EXP_MAX.name}
                                                                                    value={WORK_EXP_MAX.value}
                                                                                    onChange={(e) => this.onChange(e)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>


                                        </div>
                                        <hr />
                                        <div className="billing-title-wrap">
                                            <h3 className="widget-title pb-0">Additional Detail
                                            </h3>

                                            <div className="title-shape margin-top-5px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">

                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">Add additional requirement so that we can help you find the right candidates</span>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full pt-2">
                                                        <div className="input-box">
                                                            <div className="row">
                                                                {/* Industry Selection */}
                                                                <div className="col-lg-6 pt-3">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Industry <span className="text-danger font-size-16">*</span>
                                                                        </label>
                                                                        <div className="form-group postjob-select-container">
                                                                            <select
                                                                                className={
                                                                                    INDUSTRY_ID.error.length > 0
                                                                                        ? "form-control is-invalid postjob-select"
                                                                                        : "form-control postjob-select"
                                                                                }
                                                                                name={INDUSTRY_ID.name}
                                                                                value={INDUSTRY_ID.value}
                                                                                onChange={this.onChange}
                                                                            >
                                                                                <option value="">Select Industry</option>
                                                                                {INDUSTRY_ID.options.length > 0 &&
                                                                                    INDUSTRY_ID.options.map((item, index) => {
                                                                                        return (
                                                                                            <option key={index} value={item.INDUSTRY_ID}>
                                                                                                {item.INDUSTRY}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Gender Selection */}
                                                                <div className="col-lg-3 pt-3">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Gender
                                                                        </label>
                                                                        <div className="form-group postjob-select-container">
                                                                            <select
                                                                                className={
                                                                                    GENDER.error.length > 0
                                                                                        ? "form-control is-invalid postjob-select"
                                                                                        : "form-control postjob-select"
                                                                                }
                                                                                name={GENDER.name}
                                                                                value={GENDER.value}
                                                                                onChange={this.onChange}
                                                                            >
                                                                                <option value="BOTH">Both</option>
                                                                                <option value="MALE">Male</option>
                                                                                <option value="FEMALE">Female</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Age Selection */}
                                                                <div className="col-lg-3 pt-3">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Age
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <div className="row">
                                                                                <div className="col">
                                                                                    <input
                                                                                        className={
                                                                                            AGE_MIN.error.length > 0
                                                                                                ? "form-control is-invalid"
                                                                                                : "form-control"
                                                                                        }
                                                                                        type="number"
                                                                                        min="0"
                                                                                        placeholder="Min"
                                                                                        name={AGE_MIN.name}
                                                                                        value={AGE_MIN.value}
                                                                                        onChange={this.onChange}
                                                                                    />
                                                                                </div>
                                                                                <span className="mt-3">to</span>
                                                                                <div className="col">
                                                                                    <input
                                                                                        className={
                                                                                            AGE_MAX.error.length > 0
                                                                                                ? "form-control is-invalid"
                                                                                                : "form-control"
                                                                                        }
                                                                                        type="number"
                                                                                        min="0"
                                                                                        placeholder="Max"
                                                                                        name={AGE_MAX.name}
                                                                                        value={AGE_MAX.value}
                                                                                        onChange={this.onChange}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>




                                                    <div className="col-lg-3 column-lg-full pt-3">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Degree
                                                            </label>


                                                            <div className="form-group postjob-select-container">
                                                                <Multiselect
                                                                    placeholder='Select Educational Qualification'
                                                                    style={{
                                                                        optionContainer:
                                                                            this.state.EducationQualificationsearchKey ? { display: 'block' } : { display: 'none' }
                                                                    }}
                                                                    options={this.state.EducationQualificationList}

                                                                    onSelect={(selectedValue) => {

                                                                        this.setState({ SELECTED_EDUCATION_QUALIFICATION: selectedValue })
                                                                        this.getcourseSpecializationList(selectedValue.map((item) => {
                                                                            return item.EDUCATION_QUALIFICATION_ID
                                                                        }))
                                                                    }}
                                                                    onRemove={(selectedValue) => {
                                                                        this.setState({ SELECTED_EDUCATION_QUALIFICATION: selectedValue })
                                                                    }}
                                                                    onSearch={(e) => {
                                                                        this.getEducationQualificationList(e)
                                                                    }
                                                                    }
                                                                    selectedValues={SELECTED_EDUCATION_QUALIFICATION}
                                                                    displayValue={"COURSE_STREAM"}
                                                                    name={"EDUCATION_QUALIFICATION_ID"}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12 column-lg-full pt-3">
                                                        <div className="input-box">
                                                            <label className="label-text">
                                                                Specialization
                                                            </label>

                                                            <div className="form-group postjob-select-container">
                                                                <Multiselect
                                                                    placeholder='Select Course Specialization'
                                                                    style={{
                                                                        optionContainer:
                                                                            this.state.SPECIALIZATIONsearchKey ? { display: 'block' } : { display: 'none' }
                                                                    }}
                                                                    options={this.state.SPECIALIZATIONList}

                                                                    onSelect={(selectedValue) => {

                                                                        this.setState({ SELECTED_COURSE_SPECIALIZATION: selectedValue })
                                                                    }}
                                                                    onRemove={(selectedValue) => {
                                                                        this.setState({ SELECTED_COURSE_SPECIALIZATION: selectedValue })
                                                                    }}
                                                                    onSearch={(e) => {
                                                                        this.getcourseSpecializationList(e)
                                                                    }
                                                                    }
                                                                    selectedValues={SELECTED_COURSE_SPECIALIZATION}
                                                                    displayValue={"SPECIALIZATION"}
                                                                    name={"SPECIALIZATION_ID"}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <hr />
                                        <div className="billing-title-wrap">
                                            <h3 className="widget-title pb-0">Job Description
                                            </h3>

                                            <div className="title-shape margin-top-5px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="postjob-form-action">
                                                <div className="row">

                                                    <div className="col-md-12 pb-3">
                                                        <span className="d-block">Describe the responsibilities of this job and other specific requirements here.                                                        .</span>
                                                    </div>
                                                    <div className="col-lg-12 column-lg-full pt-2">
                                                        <div className="input-box">
                                                            <div className="row">
                                                                <div className="col-lg-12 column-lg-full">
                                                                    <div className="input-box">
                                                                        <label className="label-text">
                                                                            Job description / Additional requirement <span className="text-danger">*</span>
                                                                        </label>
                                                                        <div className="form-group">
                                                                            <textarea
                                                                                className={
                                                                                    JOB_DESCRIPTION.error.length > 0
                                                                                        ? "errorMsg"
                                                                                        : ""
                                                                                }
                                                                                name={JOB_DESCRIPTION.name}
                                                                                value={JOB_DESCRIPTION.value}
                                                                                style={{ width: "100%", padding: "10px" }}
                                                                                onChange={this.onChange}
                                                                                rows={7}
                                                                            ></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="btn-box">
                                                        <button
                                                            type="button"
                                                            className="theme-btn border-0"
                                                            onClick={() => { this.props.prevStep() }}
                                                        >
                                                            Previous
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 text-right">
                                                    <div className="btn-box">
                                                        <button
                                                            type="submit"
                                                            className="theme-btn border-0"
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>



            </React.Fragment >
        );
    }

    deleteSKills = (SKILL) => {
        const { SELECTED_SKILLS } = this.state;
        let arr = SELECTED_SKILLS.filter((item) => {
            if (item.SKILL != SKILL) {
                return item;
            }
        });
        this.setState({ SELECTED_SKILLS: arr });
    };
    onKeywordPress = (value, TYPE) => {
        if (TYPE === "SKILL") {
            searchSkill(value).then((res) => {
                if (res.status) {
                    setOptions(this, this.state.KEYWORDS.name, res.result);
                } else {
                    alert(res.error);
                }
            });
        }
    };



    skillsOnChange = (e) => {
        function getUniqueListBy(arr, key) {
            return [...new Map(arr.map((item) => [item[key], item])).values()];
        }
        let val = [];
        if (e.length > 0) {
            val = e[e.length - 1];
        }
        onChange(this, this.state.KEYWORDS.name, val);
        if (e[0]) {
            val = this.state.SELECTED_SKILLS.concat(val);
            val = val.map((item, index) => {
                if (item.SKILL) {
                    return { SKILL: item.SKILL };
                } else if (item.label) {
                    return { SKILL: item.label };
                }
            });
            val = getUniqueListBy(val, "SKILL");
            this.setState({ SELECTED_SKILLS: val });
        }
    };


    loadlist = () => {
        jobIndustryList()
            .then((res) => {
                if (res.status) {
                    setOptions(this, this.state.INDUSTRY_ID.name, res.result);
                } else {
                    alert(res.error);
                }
            })
            .catch((err) => {
                alert(err);
            });
    };
}
